<template>
    <section class="page-section">
                <div class="background-height">
                    <el-form size="small" ref="formBase" :model="formBase" label-width="80px" class="content-form">
                        <div class="form-module">
                            <div class="module-body">
                                <el-form-item label="标题" required>
                                    <el-input v-model="formBase.title" class="w300" maxlength="8" minlength="2" placeholder="2-8个中文字符"></el-input>
                                </el-form-item>
                                <el-form-item label="图片" required>
                                    <div class="margin-top-15" :class="{ 'category-pics-box': tabName != '4' }">
                                        <div class="pics-box">
                                            <el-upload
                                                :action="uploadPicUrl"
                                                list-type="picture-card"
                                                :file-list="formBase.pics"
                                                accept=".png,.jpg,.jpeg"
                                                drag
                                                :on-preview="handlePicPreview"
                                                :on-remove="handlePicRemove"
                                                :on-success="handlePicSuccess"
                                                :on-error="handlePicError"
                                                :before-upload="handlePicBeforeUpload"
                                                :limit="tabName == '4' ? 1000 : 1">
                                                <i class="el-icon-plus"></i>
                                            </el-upload>
                                        </div>
                                        <template v-if="tabName == '4'">
                                            <div class="tips">支持jpg、png格式，上传数量不限</div>
                                        </template>
                                        <template v-else>
                                            <div class="tips">支持jpg、png格式，建议尺寸：{{ tabName == '1' ? '750*560' : '750*280' }}像素</div>
                                        </template>
                                    </div>
                                </el-form-item>
                                <template v-if="tabName != '4'">
                                    <el-form-item label="链接至" required>
                                        <el-select v-model="formBase.redirectType" filterable clearable placeholder="请选择" @change="handleRedirectTypeChange">
                                            <template v-for="(row, rowIndex) in redirectTypeOptions">
                                                <el-option :label="row.label" :value="row.value" :key="rowIndex"></el-option>
                                            </template>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="服务" required v-if="formBase.redirectType == 1">
                                        <el-select v-model="formBase.productId" filterable placeholder="请选择" class="w300" :loading="commodityList.tableLoading">
                                            <el-option v-for="item in commodityList.tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="商品" required v-if="formBase.redirectType == 3">
                                        <el-select v-model="formBase.productId" filterable placeholder="请选择" class="w300" :loading="commodityList.tableLoading">
                                            <el-option v-for="item in commodityList.tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="一级分类" required v-if="formBase.redirectType == 2 || formBase.redirectType == 4">
                                        <el-select v-model="formBase.firstCategoryId" filterable clearable placeholder="请选择" class="w300" :loading="firstCategoryOptionsLoading" @change="handleFirstCategoryChange">
                                            <el-option :label="item.name" :value="item.id" v-for="(item, index) in firstCategoryOptions" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="二级分类" required v-if="(formBase.redirectType == 2 || formBase.redirectType == 4) && formBase.firstCategoryId">
                                        <el-select v-model="formBase.secondCategoryId" filterable clearable placeholder="请选择" class="w300" :loading="secondCategoryOptionsLoading">
                                            <el-option :label="item.name" :value="item.id" v-for="(item, index) in secondCategoryOptions" :key="index"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="详情页" required v-if="formBase.redirectType == 6">
                                        <el-select v-model="formBase.productId" filterable placeholder="请选择" class="w300" :loading="commodityList.tableLoading">
                                            <el-option v-for="item in commodityList.tableData" :key="item.id" :label="item.title" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </template>
                                <el-form-item>
                                    <el-button type="primary" size="small" @click="submitForm" :loading="saveLoading">保存</el-button>
                                    <el-button type="default" size="small" plain @click="goHistoryRouting">取消</el-button>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form>
                </div>
            

        <!-- 图片预览 -->
        <el-dialog :visible.sync="previewDialogShow" custom-class="preview-image-dialog">
            <img width="100%" :src="previewDialogImageUrl" alt="">
        </el-dialog>
      </section>
</template>

<script>
    import { uploadPath, shopPosterDetail, shopPosterSaveOrUpdate, commodityCategoryList, serviceManageList, commodityFilterList, shopPosterPageDetail, shopPosterPageSaveOrUpdate, shopPosterPageList } from '@/common/api';

    export default {
        name: 'shopAdvAdd',
        data() {
            return {
                id: this.$route.query.id || '',
                tabName: this.$route.query.tabname || '',

                pageLoading: false, // 页面loading

                formBase: { // 编辑表单
                    title: '', // 标题
                    pics: [], // 上传图片信息储存
                    redirectType: '', // 关联类型
                    firstCategoryId: '',
                    secondCategoryId: '',
                    productId: ''
                },

                uploadPicUrl: uploadPath + '/media/uploadPic',// 上传图片接口,
                previewDialogShow: false, // 预览图片 - 弹窗
                previewDialogImageUrl: '', // 预览图片 - url

                redirectTypeOptions: [
                    {
                        label: '服务',
                        value: 1
                    },
                    {
                        label: '服务分类',
                        value: 2
                    },
                    {
                        label: '商品',
                        value: 3
                    },
                    {
                        label: '商品分类',
                        value: 4
                    },
                    {
                        label: '企业微信二维码',
                        value: 5
                    },
                    {
                        label: '详情页',
                        value: 6
                    }
                ],

                firstCategoryOptions: [], // 一级分类
                firstCategoryOptionsLoading: false,
                secondCategoryOptions: [], // 二级分类
                secondCategoryOptionsLoading: false,

                commodityList: { // 选中的指定商品
                    tableLoading: false,
                    tableData: [],
                    page: {
                        current: 1,
                        size: 99999,
                        total: 0
                    }
                },

                saveLoading: false
            }
        },
        mounted() {
            this.getDetail();
        },
        methods: {
            /**
             * [getDetail description] 获取单个编辑信息
             * @return {[type]} [description]
             */
            getDetail(){
                if(!this.id) {
                    return false;
                }

                if(this.tabName == '4') {
                    this.pageLoading = true;

                    var params = {
                        posterPageId: this.id
                    };

                    shopPosterPageDetail(params).then(res => {
                        this.pageLoading = false;

                        const { data } = res

                        if(res.code == 0){
                            this.formBase.title = data.title;
                            let picList = []
                            if(data.pics) {
                                data.pics.map((row,index) => {
                                    const picPath = data.picPaths[index]
                                    picList.push({
                                        'name': row,
                                        'url': picPath,
                                        'response': {
                                            'data': {
                                                'url': row,
                                                'path': picPath
                                            }
                                        }
                                    });
                                })
                            }
                            this.formBase.pics = picList
                        }else{
                            this.$message({ message: res.msg, type: "error" });
                        }
                    }).catch(error => {
                        console.log(error)
                        this.$message.error('服务器异常');
                    })
                } else {
                    this.pageLoading = true;

                    var params = {
                        posterId: this.id
                    };

                    shopPosterDetail(params).then(res => {
                        this.pageLoading = false;

                        const { data } = res

                        if(res.code == 0){
                            this.formBase.title = data.title;
                            if(data.pic) {
                                this.formBase.pics.push({
                                    'name': res.data.pic,
                                    'url': res.data.picPath,
                                    'response': {
                                        'data': {
                                            'url': res.data.pic,
                                            'path': res.data.picPath
                                        }
                                    }
                                });
                            }
                            this.formBase.redirectType = data.redirectType;
                            this.formBase.firstCategoryId = data.firstCategoryId || '';
                            this.formBase.secondCategoryId = data.secondCategoryId || '';
                            this.formBase.productId = data.productId || '';

                            if(data.redirectType == 1) {
                                this.getServiceList()
                            } else if(data.redirectType == 3) {
                                this.getGoodsList()
                            } else if(data.redirectType == 2 || data.redirectType == 4) {
                                this.getFirstCategoryList()
                                if(data.firstCategoryId) {
                                    this.handleFirstCategoryChange('detail')
                                }
                            } else if(data.redirectType == 6) {
                                this.getDetailList()
                            }
                        }else{
                            this.$message({ message: res.msg, type: "error" });
                        }
                    }).catch(error => {
                        console.log(error)
                        this.$message.error('服务器异常');
                    })
                }
            },
            /**
             * [handleRedirectTypeChange description] 链接至 - 变化
             * @return {[type]} [description]
             */
            handleRedirectTypeChange() {
                let redirectType = this.formBase.redirectType
                if(redirectType == 1) {
                    // 服务
                    this.formBase.productId = ''
                    this.commodityList.tableData = []
                    this.getServiceList()
                } else if(redirectType == 3) {
                    // 商品
                    this.formBase.productId = ''
                    this.commodityList.tableData = []
                    this.getGoodsList()
                } else if(redirectType == 2 || redirectType == 4) {
                    // 商品分类
                    this.formBase.firstCategoryId = ''
                    this.formBase.secondCategoryId = ''
                    this.secondCategoryOptions = []
                    this.getFirstCategoryList()
                } else if(redirectType == 6) {
                    // 商品
                    this.formBase.productId = ''
                    this.commodityList.tableData = []
                    this.getDetailList()
                }
            },
            /**
             * [getServiceList description] 获取项目列表
             * @return {[type]}         [description]
             */
            getServiceList() {
                this.commodityList.tableLoading = true;

                let params = {
                    current: this.commodityList.page.current,
                    size: this.commodityList.page.size
                }
                serviceManageList(params).then(res =>{
                    this.commodityList.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        dataArray.map((item, index) => {
                            if(!item) {
                                dataArray.splice(index, 1);
                            }
                        })

                        this.commodityList.tableData = dataArray;
                        this.commodityList.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getGoodsList description] 获取商品
             * @return {[type]}         [description]
             */
            getGoodsList() {
                this.commodityList.tableLoading = true;

                let params = {
                    all: 1,
                    type: '',
                    relateId: '',
                    commodityName: '',
                    current: 1,
                    size: 99999
                }

                commodityFilterList(params).then(res =>{
                    this.commodityList.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.commodityList.tableData = dataArray;
                        this.commodityList.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [getFirstCategoryList description] 获取类目
             * @return {[type]}         [description]
             */
            getFirstCategoryList: function() {
                this.firstCategoryOptionsLoading = true;

                let params = {
                    type: this.formBase.redirectType == 2 ? 2 : 1
                }

                commodityCategoryList(params).then(res => {
                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data || [];
                        
                        this.firstCategoryOptions = dataArray;
                        this.firstCategoryOptionsLoading = false;
                    }
                });
            },
            /**
             * [handleFirstCategoryChange description] 监测一级类目下拉框值变化
             * @param  {[type]} val [description] 
             * @return {[type]}     [description]
             */
            handleFirstCategoryChange: function(type) {
                if(type != 'detail') {
                    this.formBase.secondCategoryId = ''
                }

                this.secondCategoryOptionsLoading = true;

                let params = {
                    type: this.formBase.redirectType == 2 ? 2 : 1,
                    firstCategoryId: this.formBase.firstCategoryId
                }

                commodityCategoryList(params).then(res => {
                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data || [];
                        
                        this.secondCategoryOptions = dataArray;
                        this.secondCategoryOptionsLoading = false;
                    }
                });
            },
            /**
             * [getDetailList description] 获取详情页
             * @return {[type]}         [description]
             */
            getDetailList() {
                this.commodityList.tableLoading = true;

                let params = {
                    current: 1,
                    size: 99999
                }

                shopPosterPageList(params).then(res =>{
                    this.commodityList.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.commodityList.tableData = dataArray;
                        this.commodityList.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleDetailPicturesBeforeUpload description] 图片上传之前格式校验
             * @param  {[type]} file [description]
             * @return {[type]}      [description]
             */
            handlePicBeforeUpload: function(file) {
                let fileName = file.name,
                    fileNameArr = fileName.split('.'),
                    fileType = fileNameArr[fileNameArr.length - 1],
                    supportArr = ['jpg', 'jpeg', 'png'];

                if(supportArr.indexOf(fileType) == -1) {
                    this.$message.error('请上传jpg、jpeg、png格式的图片');
                    return false;
                }
            },
            handlePicPreview: function(file) {
                this.previewDialogImageUrl = file.url;
                this.previewDialogShow = true;
            },
            handlePicSuccess: function(response, file, fileList) {
                this.formBase.pics = fileList;
            },
            handlePicError: function(err, file, fileList) {
                this.$message.error('图片上传失败');
                this.formBase.pics = fileList;
            },
            handlePicRemove: function(file, fileList) {
                this.formBase.pics = fileList;
            },
            /**
             * [submitForm description] 表单验证事件
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            submitForm(formName) {
                if(!this.formBase.title) {
                    this.$message.error('请输入标题');
                    return false;
                }
                if(this.formBase.pics.length == 0) {
                    this.$message.error('请上传图片');
                    return false;
                }
                if(this.tabName != '4') {
                    if(!this.formBase.redirectType) {
                        this.$message.error('请选择链接至');
                        return false;
                    }
                    let redirectType = this.formBase.redirectType
                    if(redirectType == 1) {
                        // 服务
                        if(!this.formBase.productId) {
                            this.$message.error('请选择项目');
                            return false;
                        }
                    } else if(redirectType == 3) {
                        // 商品
                        if(!this.formBase.productId) {
                            this.$message.error('请选择商品');
                            return false;
                        }
                    } else if(redirectType == 2 || redirectType == 4) {
                        // 商品分类
                        if(!this.formBase.firstCategoryId) {
                            this.$message.error('请选择一级分类');
                            return false;
                        }
                        if(!this.formBase.secondCategoryId) {
                            this.$message.error('请选择二级分类');
                            return false;
                        }
                    } else if(redirectType == 6) {
                        // 商品
                        if(!this.formBase.productId) {
                            this.$message.error('请选择详情页');
                            return false;
                        }
                    }
                }
                
                if(this.tabName == '4') {
                    this.saveLoading = true;

                    let params = {
                        id: this.id,
                        title: this.formBase.title,
                        pics: this.formBase.pics.map(row => { return row.response.data.url })
                    };

                    shopPosterPageSaveOrUpdate(params).then(res => {
                        this.saveLoading = false;
                        if(res.code == 0){
                            this.$message({ message: '保存成功', type: "success" });
                            this.goHistoryRouting();
                        }else{
                            this.$message({ message: res.msg, type: "error" });
                        }
                    }).catch(error => {
                        this.saveLoading = false;
                        this.$message.error('服务器异常');
                    })
                } else {
                    this.saveLoading = true;

                    let params = {
                        id: this.id,
                        title: this.formBase.title,
                        pic: this.formBase.pics[0].response.data.url,
                        adType: this.tabName,
                        redirectType: this.formBase.redirectType,
                        firstCategoryId: this.formBase.firstCategoryId,
                        secondCategoryId: this.formBase.secondCategoryId,
                        productId: this.formBase.productId
                    };

                    shopPosterSaveOrUpdate(params).then(res => {
                        this.saveLoading = false;
                        if(res.code == 0){
                            this.$message({ message: '保存成功', type: "success" });
                            this.goHistoryRouting();
                        }else{
                            this.$message({ message: res.msg, type: "error" });
                        }
                    }).catch(error => {
                        this.saveLoading = false;
                        this.$message.error('服务器异常');
                    })
                }
            },
            /**
             * [goHistoryRouting description] 去上一个记忆路由
             * @return {[type]} [description]
             */
            goHistoryRouting(){
                this.$router.push({path: '/shop/adv/list', query: { 'tabname': this.tabName }});
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    .pics-box{
        ::v-deep .el-upload-list--picture-card{
            .el-upload-list__item{
                position: relative;
                width: 100px;
                height: 100px;
                border-radius: 2px;

                .el-upload-list__item-thumbnail{
                    @include position(absolute, none, 50%, none, none, 50%);
                    @include translate(-50%, -50%, 0);
                }

                .el-progress{
                    width: 80px;
                    height: 80px;

                    .el-progress-circle{
                        width: 80px !important;
                        height: 80px !important;
                    }
                }

                .el-icon-close-tip{
                    display: none;
                }
            }
        }

        ::v-deep .el-upload--picture-card{
            width: 100px;
            height: 100px;
            line-height: 98px;
            border-radius: 2px;

            .el-upload-dragger{
                width: 98px;
                height: 98px;
                border: none;

                .el-icon-plus{
                    font-size: $baseFS;
                }
            }
        }
    }

    .category-pics-box{
        .pics-box{
            width: 100px;
            height: 100px;
            overflow: hidden;
        }
    }

    ::v-deep .select-mask{
        @include position(absolute, 3, 0, 0, 0, -42px);
        width: 42px;
        background: #FFF;
    }
</style>
